import PageLayer from "@Layouts/views/PageLayer";
import MyCitLayer from "@DataPages/components/MyCIT/MyCitLayer";

// Icons
import CIT from "@/assets/icons/dataPages/myCIT/MyCIT.svg";

export default function MyCIT() {
	return (
		<PageLayer title={"My Contracts In Transit"} icon={CIT}>
			<MyCitLayer />
		</PageLayer>
	);
}
